import React from 'react';

const DocumentsStateIcon = ({
  width = '14',
  height = '14',
  fill = '#EF4921',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.613 1.45265e-07C4.10495 0.000214092 3.61034 0.163186 3.20168 0.465022C2.79302 0.766859 2.4918 1.19168 2.3422 1.6772H1.8186C1.33628 1.6772 0.873709 1.8688 0.532656 2.20986C0.191602 2.55091 0 3.01348 0 3.4958L0 9.6446C0.000371116 10.1267 0.192137 10.5889 0.53315 10.9296C0.874164 11.2704 1.33652 11.4618 1.8186 11.4618H5.1184V6.2762C5.1184 5.635 5.3466 4.9938 5.7904 4.4982C6.2384 4.0012 6.8824 3.6876 7.588 3.6876H9.226V3.4958C9.22618 3.25698 9.17933 3.02046 9.0881 2.79975C8.99688 2.57903 8.86308 2.37845 8.69433 2.20945C8.52559 2.04044 8.32521 1.90633 8.10464 1.81477C7.88407 1.72321 7.64762 1.67598 7.4088 1.6758H6.8852C6.73528 1.19031 6.43375 0.765633 6.02483 0.464044C5.61591 0.162454 5.12111 -0.00017743 4.613 1.45265e-07ZM12.9318 5.0876H7.588C7.44454 5.08914 7.30302 5.12099 7.17273 5.18107C7.04244 5.24115 6.92633 5.32809 6.832 5.4362C6.62801 5.66828 6.5164 5.96722 6.5184 6.2762V12.81C6.5164 13.119 6.62801 13.4179 6.832 13.65C7.0322 13.874 7.3038 13.9986 7.588 13.9986H12.9318C13.0752 13.9968 13.2167 13.9648 13.3469 13.9048C13.4772 13.8447 13.5933 13.7579 13.6878 13.65C13.8913 13.4177 14.0024 13.1188 14 12.81V6.2762C14.002 5.96722 13.8904 5.66828 13.6864 5.4362C13.5921 5.32809 13.476 5.24115 13.3457 5.18107C13.2154 5.12099 13.0739 5.08914 12.9304 5.0876H12.9318Z"
      fill={fill}
    />
  </svg>
);

export default DocumentsStateIcon;
